module.exports = __webpack_public_path__ + "static/img/repair3.0ab4ae6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/repair3.gif
// module id = te0/
// module chunks = 0